module.exports = __webpack_public_path__ + "static/media/SacredHeartSchoolRoslindale.ae351a6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/SacredHeartSchoolRoslindale.png
// module id = 659
// module chunks = 0